<template>
  <td>
    <div class="btn-actions-container d-flex justify-content-end">
      <img v-if="onExport" svg-inline class="icon btn btn-actions height-35" :src="exportIcon" @click="onExportHandler" />
      <img v-if="onDelete" svg-inline class="icon btn btn-actions height-35" :src="removeIcon" @click="onDeleteHandler" />
      <img v-if="onEdit" svg-inline class="icon btn btn-actions height-35" :src="editIcon" @click="onEditHandler" />
    </div>
  </td>
</template>

<script>
import removeIcon from '../../assets/icons/remove.svg';
import editIcon from '../../assets/icons/edit.svg';
import exportIcon from '../../assets/icons/export.svg';

export default {
  name: 'ActionCell',
  props: {
    dataItem: {
      type: Object,
      default: () => {},
    },
    onExport: {
      type: Function,
      default: null,
    },
    onDelete: {
      type: Function,
      default: null,
    },
    onEdit: {
      type: Function,
      default: null,
    },
    getTableData: {
      type: Function,
      default: () => {},
    },
  },
  data: function() {
    return {
      removeIcon,
      editIcon,
      exportIcon,
    };
  },
  methods: {
    async onExportHandler() {
      await this.onExport(this.dataItem.id);
    },
    async onDeleteHandler() {
      const isDone = await this.onDelete(this.dataItem);
      if (isDone) {
        await this.getTableData();
      }
    },
    async onEditHandler() {
      await this.onEdit(this.dataItem);
    },
  }
};
</script>

<style scoped lang="scss">
.height-35 {
  height: 35px;
}
</style>
